import "./scss/plugins/_swiper.scss";
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const swiper = new Swiper(".site-swiper", {
  modules: [Navigation, Pagination],
  spaceBetween: 30,
  autoHeight: true,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 3,
    },
  },
});
const slide_title = document.querySelectorAll(".hero-swiper .swiper-slide");

const hero_swiper = new Swiper(".hero-swiper", {
  modules: [Pagination, Autoplay],
  loop: true,
  speed: 0,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="swiper-pagination-button ' + className + '">' + slide_title[index].dataset.title + "</span>";
    },
  },
});
